import { Link, useForm } from '@inertiajs/react'
import type { FormEvent } from 'react'
import AuthShell, { Field, SubmitButton } from '@/components/AuthShell'
import { t } from '@/lib/i18n'

export default function Login() {
  const form = useForm({ email_address: '', password: '' })

  const submit = (e: FormEvent) => {
    e.preventDefault()
    form.post('/session')
  }

  return (
    <AuthShell
      title={t('auth.login.title')}
      subtitle={t('auth.login.subtitle')}
      footer={
        <>
          {t('auth.login.no_account')}<Link href="/registration/new" className="text-brand font-semibold">{t('auth.register.title')}</Link>
        </>
      }
    >
      <form onSubmit={submit} className="grid gap-4">
        <Field
          label={t('auth.email')}
          type="email"
          autoComplete="username"
          autoFocus
          required
          value={form.data.email_address}
          error={form.errors.email_address}
          onChange={(e) => form.setData('email_address', e.target.value)}
        />
        <Field
          label={t('auth.password')}
          type="password"
          autoComplete="current-password"
          required
          maxLength={72}
          value={form.data.password}
          error={form.errors.password}
          onChange={(e) => form.setData('password', e.target.value)}
        />
        <SubmitButton disabled={form.processing}>{form.processing ? t('auth.login.submitting') : t('auth.login.title')}</SubmitButton>
      </form>
      <div className="text-center">
        <Link href="/passwords/new" className="text-muted text-sm hover:text-brand">{t('auth.login.forgot')}</Link>
      </div>
    </AuthShell>
  )
}
